// global cc debug functionality for console.log
const _cc_prod_domains = ['www.champlain.edu'];
// suppress debug by default on production/pantheon site OR in any environment 
// where the theme is configured as portable (domain will vary in that case)
const _cc_is_prod = _cc_prod_domains.includes(window.location.hostname) || CC_CONSTANTS.isPortable || CC_CONSTANTS.isNonWp;
const _cc_debug_value = new URL(document.location).searchParams.get('debug');
const _cc_debug_suppress = _cc_debug_value === '0' || _cc_debug_value === 'false';
const _cc_debug_param = _cc_debug_value !== null && !_cc_debug_suppress;

window.cc_debug_flag = (!_cc_is_prod || _cc_debug_param) && !_cc_debug_suppress;
console.cclog = (...args) => window.cc_debug_flag && console.log(...args);

if (CC_CONSTANTS.isNonWp) console.cclog('[cclog] main.js has been loaded outside of WordPress');